export const nullOrUndefined = (value: any) => {
  return value === null || value === undefined;
};

export const asFloat = (value: number | string): number => {
  if (typeof value === 'string') {
    return parseFloat(value);
  }
  return value;
};
